import { IColumnHookInput, IColumnHookOutput } from 'dromo-uploader-react'
import { ITableMessage } from 'dromo-uploader-js'

const zipCodeRegex = /^((\d{5}(-\d{4})?)|([A-Z]\d[A-Z] \d[A-Z]\d))$/

export function addZipCodeLeadingZeros(
  values: IColumnHookInput[]
): IColumnHookOutput[] {
  return values.map((row) => {
    const value = row.value as string | undefined

    // empty or contains invalid characters - can't process
    if (!value || /[^\d-]/.test(value)) {
      return row
    }
    // zip code is valid - don't change
    if (zipCodeRegex.test(value)) {
      return row
    }
    // add leading zeros
    const zips = value.split('-')
    const hasAddOn = zips.length === 2
    const paddedZip = `${zips[0].padStart(5, '0')}${
      hasAddOn ? '-' + zips[1].padStart(4, '0') : ''
    }`
    const newRow = {
      index: row.index,
      value: paddedZip,
      info: [
        {
          message: 'Prepended leading zero(s) to zip code',
          level: 'info' as const,
        },
      ],
    }
    return newRow
  })
}

export function validateZipcode(value: string): ITableMessage[] {
  if (!value) {
    return []
  }
  if (!value.match(zipCodeRegex)) {
    return [
      {
        message:
          'Zip codes must be in the format of `01234` or `01234-5678` (US) or `A0A 0A0` (Canada)',
        level: 'error',
      },
    ]
  }
  return []
}
